import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment'
import Table from "react-bootstrap/Table";
import Header from "../../Components/Header";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { addDocAndInfo, addSlc, deleteDocAndInfo, getDocAndInfo} from "../../reducers/commonReducer";
import { Button } from "react-bootstrap";
import { baseUrl } from "../../const";
import SlcAction from "./DocAction";

const DocList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("x-auth-token")) {
      navigate("/");
    }
    dispatch(getDocAndInfo());
  }, []);
  const { getDocAndInfoList } = useSelector((state) => state.commonReducer);
  
  return (
    <>
      <Header />
      <div className="container">
        <Row className="mt-4 mb-2 user-table">
          <Col md={6}>
            <SlcAction title={"Add"} api={addDocAndInfo}/>
          </Col>
        </Row>
        <div className="overflow-auto">
          <Table striped bordered hover size="sm" className="overflow-scroll">
            <thead>
              <tr>
                <th>Sr</th>
                <th>Name</th>
                <th>Date</th>
                <th>View Doc and Info</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!!getDocAndInfoList &&
                getDocAndInfoList?.map((data, index) => {
                  return (
                    <tr key={data.id}>
                      <td>{index + 1}.</td>
                      <td>{data?.name}</td>
                      <td>{moment(data?.createdAt).format("MMM Do YY")}</td>
                      <td className="table-img">
                      <Button onClick={() => window.open(`${baseUrl}/${data?.slc}`, '_blank')} alt={data?.name}>View</Button>
                      </td>
                      <td>
                        {/* <SlcAction title={"Edit"} api={updateSlc} name={data?.name} slcNo={data?.slcNo} fatherName={data?.fatherName} id={data?.id}/> */}
                        <Button variant="danger" onClick={async() =>{
                          const userConfirmed = window.confirm('Are you sure you want to perform this action?');
                          if(userConfirmed){
                            await dispatch(deleteDocAndInfo(data?.id))
                            await dispatch(getDocAndInfo());
                          }
                        }}><i className="bi bi-trash-fill"></i></Button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default DocList;
